import { Component, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { TranslatePipe } from '@core/i18n-legacy';
import { InputComponent, LabelComponent, FormFieldComponent } from '@core/user-interface-legacy';

import { noopFormGroupTransform } from '../../../utils';

@Component({
  selector: 'rt-simple-question',
  templateUrl: './single-input.component.html',
  styleUrls: ['./single-input.component.less'],
  imports: [ReactiveFormsModule, FormFieldComponent, LabelComponent, InputComponent, TranslatePipe],
})
export class SingleInputComponent {
  public defineForm = input.required({
    transform: noopFormGroupTransform<{
      question: string;
      hint: string;
    }>,
  });
  public hindDisabled = input(false);
  public isRequired = input(false);
}
